import i18next from 'i18next';

i18next.addResources('es_CL', 'paymentBrick', {
  invalidCard:
    'Lo sentimos, tu tarjeta no aplica para esta promoción. Verifica que los datos estén correctos e intenta nuevamente.'
});
